/**
 * HELPER 
 * UserHelper 
 * @method getId 
 * @method getUserOrganizations
 * @method getPermissionValueById
 * @method getPermissionValueById
*/
var UserHelper = (function () {
    // var builder = new SumoPredicateBuilder();
    function UserHelperInstance(){
        this.builder = new SumoPredicateBuilder();
    }
    /**
     * This method will get a list of Agents filtered by OrganizationId 
     * @param  {} lOrganizationId
     */
    UserHelperInstance.prototype.getId = function(lOrganizationId){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        // this.builder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if(lOrganizationId){
            this.builder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        this.builder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lMyAgents = query(getDataItems('Users'), this.builder.RootExpression);
        var AgentID = null;
        if (lMyAgents.length > 0) {
            for (lKey in lMyAgents) {
                AgentID = lMyAgents[lKey].Id
                break;
            }
        }
        if(AgentID === null || !AgentID){
            return gUserDetails.UserId
        }
        return AgentID;
    };
    //lPredicateBuilder


    /**
         * This Method will retrieve the Agent List filter by a Given Attribute  
         * @param  {} aAttribute
         * @param  {} aValue
         * e.g. 
         * var agents= UserHelper.getBy('OrganizationId',1234); 
         */
    UserHelperInstance.prototype.getByIds = function(Ids){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('Id', Ids, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        return query(getDataItems('Users'), this.builder.RootExpression);
    };
    /**
     * This Method will retrieve the Agent List filter by a Given Attribute  
     * @param  {} aAttribute
     * @param  {} aValue
     * e.g. 
     * var agents= UserHelper.getBy('OrganizationId',1234); 
     */
    UserHelperInstance.prototype.getBy = function(aAttribute,aValue){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional(aAttribute, aValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        return query(getDataItems('Users'), this.builder.RootExpression);
    };
    UserHelperInstance.prototype.getCultureId = function () {
        const CULTURE_PREFERENCE = 13;
         var lPreferences = getUserPreferences(CULTURE_PREFERENCE),
            lPreference,lCultureId = 1;
        if (count(lPreferences) > 0) {
            lPreference = lPreferences['CultureId'];
            if (!isNullOrUndefined(lPreference) && lPreference.Value != -1) {
                lCultureId = parseInt(lPreference.Value);
            }
        }
        return lCultureId;
    }
    UserHelperInstance.prototype.getSelectedLanguage = function () {
        const lRegions = getDataItems('Culture');
        const lCultureId = this.getCultureId();
        if (isNullOrUndefined(lRegions)) {
            return 'EN'; //Default to 1 
        }
        return lRegions[lCultureId].Name;
    }
    UserHelperInstance.prototype.getPhoneCodes = function () {
        const lCodes = ['MX','US'];
        return lCodes;
    }
    return new UserHelperInstance();
})();

if (typeof exports !== 'undefined') {
    module.exports = UserHelper;
}